export const mainWhite = '#fff';
export const mainBlack = '#000';
export const mainOrange = '#DDAA46';
export const mainBlue = "#045D5D";
export const mainGrey = "#eae6eb";